// Web shim for React Native Switch
import React from 'react';
import { View, Pressable, StyleSheet } from 'react-native';

interface SwitchProps {
  value?: boolean;
  onValueChange?: (value: boolean) => void;
  disabled?: boolean;
  trackColor?: { false?: string; true?: string };
  thumbColor?: string;
  ios_backgroundColor?: string;
  style?: any;
  testID?: string;
}

const Switch = React.forwardRef<any, SwitchProps>((props, ref) => {
  const {
    value = false,
    disabled = false,
    onValueChange,
    trackColor,
    thumbColor = '#FFFFFF',
    ios_backgroundColor,
    style,
    testID,
    ...otherProps
  } = props;

  const handlePress = (e?: any) => {
    e?.stopPropagation?.();
    e?.preventDefault?.();
    if (!disabled && onValueChange) {
      console.log('[Web Switch] handlePress called, current value:', value, 'new value:', !value);
      onValueChange(!value);
    } else {
      console.log('[Web Switch] handlePress called but disabled or no onValueChange', { disabled, hasOnValueChange: !!onValueChange });
    }
  };

  const trackColorFalse = trackColor?.false || ios_backgroundColor || '#e9e9ea';
  // Default to a blue color, but allow trackColor.true to override
  const trackColorTrue = trackColor?.true || '#007AFF';

  return (
    <Pressable
      ref={ref}
      onPress={handlePress}
      onPressIn={(e) => {
        e?.stopPropagation?.();
        console.log('[Web Switch] onPressIn');
      }}
      onPressOut={(e) => {
        e?.stopPropagation?.();
        console.log('[Web Switch] onPressOut');
      }}
      disabled={disabled}
      style={({ pressed }) => [
        styles.container,
        {
          backgroundColor: value ? trackColorTrue : trackColorFalse,
          opacity: disabled ? 0.5 : pressed ? 0.8 : 1,
        },
        style,
      ]}
      testID={testID}
      {...otherProps}
    >
      <View
        style={[
          styles.thumb,
          {
            backgroundColor: thumbColor,
            transform: [{ translateX: value ? 22 : 2 }],
          },
        ]}
      />
    </Pressable>
  );
});

Switch.displayName = 'Switch';

const styles = StyleSheet.create({
  container: {
    width: 51,
    height: 31,
    borderRadius: 15.5,
    justifyContent: 'center',
    padding: 2,
    cursor: 'pointer',
    userSelect: 'none',
    transition: 'background-color 0.2s ease',
  },
  thumb: {
    width: 27,
    height: 27,
    borderRadius: 13.5,
    backgroundColor: '#FFFFFF',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    transition: 'transform 0.2s ease',
  },
});

export default Switch;
